import React, { useEffect, useState } from 'react'
import firebase from '../firebase'
import Card from "@material-ui/core/Card"
import Switch from '@material-ui/core/Switch'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useLocation } from 'react-router-dom'

const Themeswitch = ({ onToggleDark }) => {
  const [isLogged, setIsLogged] = useState(false)
  const [isChecked, setIsChecked] = useState(false)
  const matches = useMediaQuery('(min-width:420px)')
  const mobilesm = useMediaQuery('(min-width:360px)')
  const location = useLocation()

  useEffect(() => {
    if (firebase.getCurrentUsername()) {
      setIsLogged(true)
    } else {
      setIsLogged(false)
    }
  }, [])

  useEffect(() => {
    if (firebase.getCurrentUsername()) {
      setIsLogged(true)
    } else {
      setIsLogged(false)
    }
  }, [location.pathname])

  const checkdark = localStorage.getItem('darkmode')

  useEffect(() => {
    if (checkdark === 'true') {
      setIsChecked(true)
    } else {
      setIsChecked(false)
    }
  }, [checkdark])

const handleChange = (event) => {
  setIsChecked(event.target.checked)
  onToggleDark()
}
  return (
    <main>
      {!isLogged ?
        <Card style={{ paddingLeft: 0 }}>
          <FormControlLabel style={{ paddingTop: 5, paddingBottom: 5, paddingLeft: 10 }}
            control={
              <Switch onChange={handleChange} checked={isChecked} />
            }
            label="Dark"
          />
        </Card>
        :
        <div>
          {matches ?
            <Card style={{ paddingRight: 128 }}>
              <FormControlLabel style={{ float: 'right', paddingTop: 5, paddingBottom: 5, paddingRight: 0 }}
                control={
                  <Switch onChange={handleChange} checked={isChecked} />
                }
                label="Dark"
                labelPlacement="start"
              />
            </Card>
            :
            <span>
              {mobilesm ?
                <Card style={{ paddingRight: 84 }}>
                  <FormControlLabel style={{ float: 'right', paddingTop: 5, paddingBottom: 5, paddingRight: 10 }}
                    control={
                      <Switch onChange={handleChange} checked={isChecked} />
                    }
                  />
                </Card>
                :
                <Card style={{ paddingLeft: 98 }}>
                  <FormControlLabel style={{ paddingTop: 5, paddingBottom: 5, paddingRight: 10 }}
                    control={
                      <Switch onChange={handleChange} checked={isChecked} />
                    }
                  />
                </Card>
              }
            </span>
          }
        </div>
      }
    </main>
  )
}

export default Themeswitch